'use strict';

var MultiSelectComboboxListItemFactory = function MultiSelectComboboxListItemFactory() {
  var ListItem = function ListItem(data) {
    this.originalData = data;
    this.dropdownVisibleValue = data.dropdownVisibleValue || data.value;
    this.selected = !!data.selected;
  };
  return ListItem;
};
MultiSelectComboboxListItemFactory.$inject = [];
module.exports = MultiSelectComboboxListItemFactory;